import { createSlice } from '@reduxjs/toolkit';

const projectSlice = createSlice({
  name: 'project',
  initialState: {
    projectId: null,
    projectName: 'Yeni Proje',
    ownerId: null,
    currentVersion: 0,
    hasDraft: false,
    isDirty: false,
    lastSavedAt: null,
    lastDraftAt: null,
    isLoading: false,
    isSaving: false,
    shareLinks: [],
    shareAccess: null, // { partyTypeId, accessLevel, token }
    projectMetadata: {}, // { city, district, neighborhood, street, ada, pafta, parsel, client }
  },
  reducers: {
    setProject(state, action) {
      const { projectId, projectName, ownerId, currentVersion, hasDraft } = action.payload;
      state.projectId = projectId;
      state.projectName = projectName || state.projectName;
      state.ownerId = ownerId || state.ownerId;
      state.currentVersion = currentVersion ?? state.currentVersion;
      state.hasDraft = hasDraft ?? state.hasDraft;
      state.isDirty = false;
    },
    setProjectName(state, action) {
      state.projectName = action.payload;
    },
    setProjectDirty(state) {
      state.isDirty = true;
    },
    clearProjectDirty(state) {
      state.isDirty = false;
    },
    setProjectLoading(state, action) {
      state.isLoading = action.payload;
    },
    setProjectSaving(state, action) {
      state.isSaving = action.payload;
    },
    projectSaved(state, action) {
      const { version, savedAt } = action.payload;
      state.currentVersion = version;
      state.lastSavedAt = savedAt;
      state.isDirty = false;
      state.isSaving = false;
    },
    draftSaved(state, action) {
      state.lastDraftAt = action.payload.savedAt;
      state.hasDraft = true;
      state.isDirty = false;
      state.isSaving = false;
    },
    setShareLinks(state, action) {
      state.shareLinks = action.payload;
    },
    setShareAccess(state, action) {
      state.shareAccess = action.payload;
    },
    setProjectMetadata(state, action) {
      state.projectMetadata = action.payload || {};
    },
    setLayoutSettings(state, action) {
      state.projectMetadata = {
        ...state.projectMetadata,
        layoutSettings: {
          ...(state.projectMetadata.layoutSettings || {}),
          ...action.payload,
        },
      };
      state.isDirty = true;
    },
    resetProject(state) {
      state.projectId = null;
      state.projectName = 'Yeni Proje';
      state.ownerId = null;
      state.currentVersion = 0;
      state.hasDraft = false;
      state.isDirty = false;
      state.lastSavedAt = null;
      state.lastDraftAt = null;
      state.isLoading = false;
      state.isSaving = false;
      state.shareLinks = [];
      state.shareAccess = null;
      state.projectMetadata = {};
    },
  },
});

export const {
  setProject,
  setProjectName,
  setProjectDirty,
  clearProjectDirty,
  setProjectLoading,
  setProjectSaving,
  projectSaved,
  draftSaved,
  setShareLinks,
  setShareAccess,
  setProjectMetadata,
  setLayoutSettings,
  resetProject,
} = projectSlice.actions;

export default projectSlice.reducer;
